export default __webpack_public_path__ + "static/sergey-colored-55e87f1ac78fc79ae7619031cbb7b31c.jpg";